export enum AuthLoginResult {
    ok = 0,
    unspecifiedError = 1,
    invalidUserName = 2,
    invalidPassword = 3,
    mustChangePassword = 4,
    accountJustLocked = 5,
    accountLocked = 6,
    secondFactorNeeded = 7,
    secondFactorInvalid = 8,
    secondFactorExpired = 9,
    needsInformation = 10,
    answerQuestions = 11,
    userInactive = 12
}
export namespace AuthLoginResult{
    export function getName(value: AuthLoginResult): string {
        switch (value) {
            case AuthLoginResult.ok:
                return "ok";
            case AuthLoginResult.unspecifiedError:
                return "unspecifiedError";
            case AuthLoginResult.invalidUserName:
                return "invalidUserName";
            case AuthLoginResult.invalidPassword:
                return "invalidPassword";
            case AuthLoginResult.mustChangePassword:
                return "mustChangePassword";
            case AuthLoginResult.accountJustLocked:
                return "accountJustLocked";
            case AuthLoginResult.accountLocked:
                return "accountLocked";
            case AuthLoginResult.secondFactorNeeded:
                return "secondFactorNeeded";
            case AuthLoginResult.secondFactorInvalid:
                return "secondFactorInvalid";
            case AuthLoginResult.secondFactorExpired:
                return "secondFactorExpired";
            case AuthLoginResult.needsInformation:
                return "needsInformation";
            case AuthLoginResult.answerQuestions:
                return "answerQuestions";
            case AuthLoginResult.userInactive:
                return "userInactive";
            default:
                return "???";
        }
    }
}
